// extracted by mini-css-extract-plugin
module.exports = {"Emoji":"qy_a vh_i vh_q vh_j"};